.container {
  display: flex;
  gap: 20px;
  align-items: center;
}

.checkButton {
  white-space: nowrap;
  transition: all ease .2s;
}